export default "__VITE_ASSET__BAiJAPDw__"